export enum Feature {
  ATTENDANCE = 'ATTENDANCE',
  ADMINISTRATION = 'ADMINISTRATION'
}
